import { PrismicPicture } from 'components';

import Styles from './Banner.styles';
import { useLoyaltyIncentiveCampaign } from '../../hooks';

export const Banner = () => {
  const { data } = useLoyaltyIncentiveCampaign();

  return (
    <Styles.ImageWrapper>
      <PrismicPicture image={data?.banner} />
    </Styles.ImageWrapper>
  );
};
